/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/Cookiebanner.ts":
/*!*****************************!*\
  !*** ./src/Cookiebanner.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CookieBanner)
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var CookieBanner = /*#__PURE__*/function (_HTMLElement) {
  function CookieBanner() {
    var _this;
    _classCallCheck(this, CookieBanner);
    _this = _callSuper(this, CookieBanner);
    _this.panelConsent = null;
    _this.panelDetails = null;
    _this.tabConsent = null;
    _this.tabDetails = null;
    _this.consentApiReady = false;
    _this.showConsentTab = _this.showConsentTab.bind(_this);
    _this.showDetailsTab = _this.showDetailsTab.bind(_this);
    _this.initSyncedCheckboxes = _this.initSyncedCheckboxes.bind(_this);
    _this.initConsentApis = _this.initConsentApis.bind(_this);
    _this.bindActionButtons = _this.bindActionButtons.bind(_this);
    _this.handleAllowAll = _this.handleAllowAll.bind(_this);
    _this.handleAllowSelected = _this.handleAllowSelected.bind(_this);
    _this.handleReject = _this.handleReject.bind(_this);
    _this.applyConsent = _this.applyConsent.bind(_this);
    _this.getSelections = _this.getSelections.bind(_this);
    _this.showBanner = _this.showBanner.bind(_this);
    _this.hideBanner = _this.hideBanner.bind(_this);
    _this.ensureGtag = _this.ensureGtag.bind(_this);
    _this.getOverlay = _this.getOverlay.bind(_this);
    _this.restoreSelections = _this.restoreSelections.bind(_this);
    return _this;
  }
  _inherits(CookieBanner, _HTMLElement);
  return _createClass(CookieBanner, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        var showBanner, recall;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.tabConsent = this.querySelector("#tab-consent");
              this.tabDetails = this.querySelector("#tab-details");
              this.panelConsent = this.querySelector("#panel-consent");
              this.panelDetails = this.querySelector("#panel-details");
              if (this.tabConsent) this.tabConsent.addEventListener("click", this.showConsentTab);
              if (this.tabDetails) this.tabDetails.addEventListener("click", this.showDetailsTab);
              _context.n = 1;
              return this.initConsentApis();
            case 1:
              this.showConsentTab();
              this.initSyncedCheckboxes();
              // Check if banner should show BEFORE seeding localStorage
              _context.n = 2;
              return this.checkConsentBannerInteraction();
            case 2:
              showBanner = _context.v;
              if (showBanner) {
                _context.n = 3;
                break;
              }
              this.seedSelectionsFromHtmlIfFirstVisit();
              _context.n = 3;
              return this.restoreSelections();
            case 3:
              this.bindActionButtons();
              recall = document.getElementById("recall-consent-banner");
              if (recall) {
                recall.addEventListener("click", function (event) {
                  event.preventDefault();
                  _this2.showBanner();
                });
              }
              if (showBanner) {
                this.showBanner();
              }
            case 4:
              return _context.a(2);
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "checkConsentBannerInteraction",
    value: function checkConsentBannerInteraction() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee2() {
        var _a, _b, _c, _d, _e, saved, visitorConsent, empty, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              saved = localStorage.getItem("cookieSelections");
              if (!saved) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, false);
            case 1:
              if (!(!this.consentApiReady || !((_b = (_a = window.Shopify) === null || _a === void 0 ? void 0 : _a.customerPrivacy) === null || _b === void 0 ? void 0 : _b.currentVisitorConsent))) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2, true);
            case 2:
              _context2.p = 2;
              _context2.n = 3;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 3:
              visitorConsent = _context2.v;
              empty = ((_c = visitorConsent.preferences) !== null && _c !== void 0 ? _c : "") === "" && ((_d = visitorConsent.analytics) !== null && _d !== void 0 ? _d : "") === "" && ((_e = visitorConsent.marketing) !== null && _e !== void 0 ? _e : "") === "";
              return _context2.a(2, empty);
            case 4:
              _context2.p = 4;
              _t = _context2.v;
              return _context2.a(2, true);
          }
        }, _callee2, this, [[2, 4]]);
      }));
    }
  }, {
    key: "showConsentTab",
    value: function showConsentTab() {
      if (this.panelConsent && this.panelDetails && this.tabConsent && this.tabDetails) {
        this.panelConsent.classList.remove("!tw-hidden");
        this.panelConsent.classList.add("active");
        this.panelDetails.classList.add("!tw-hidden");
        this.panelDetails.classList.remove("active");
        this.tabConsent.classList.add("active");
        this.tabDetails.classList.remove("active");
      }
    }
  }, {
    key: "showDetailsTab",
    value: function showDetailsTab() {
      if (this.panelConsent && this.panelDetails && this.tabConsent && this.tabDetails) {
        this.panelConsent.classList.add("!tw-hidden");
        this.panelConsent.classList.remove("active");
        this.panelDetails.classList.remove("!tw-hidden");
        this.panelDetails.classList.add("active");
        this.tabConsent.classList.remove("active");
        this.tabDetails.classList.add("active");
      }
    }
  }, {
    key: "initSyncedCheckboxes",
    value: function initSyncedCheckboxes() {
      var all = Array.from(this.querySelectorAll("input.ed-checkbox[data-consent]"));
      var onChange = function onChange(event) {
        var target = event.currentTarget;
        var key = target.dataset.consent;
        if (!key) return;
        var checked = target.checked;
        all.forEach(function (other) {
          if (other === target) return;
          if (other.dataset.consent !== key) return;
          if (!other.disabled) other.checked = checked;
        });
      };
      all.forEach(function (checkbox) {
        return checkbox.addEventListener("change", onChange);
      });
      var byKey = new Map();
      all.forEach(function (checkbox) {
        var key = checkbox.dataset.consent;
        if (!byKey.has(key)) byKey.set(key, []);
        byKey.get(key).push(checkbox);
      });
      Array.from(byKey.values()).forEach(function (group) {
        var source = group[0];
        group.slice(1).forEach(function (checkbox) {
          if (!checkbox.disabled) checkbox.checked = source.checked;
        });
      });
    }
  }, {
    key: "initConsentApis",
    value: function initConsentApis() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee4() {
        var _this3 = this;
        var _a, _b, _c, _d, localStorageCookieSelections, selections, defaultConsent;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.ensureGtag();
              localStorageCookieSelections = localStorage.getItem("cookieSelections");
              console.log("Local cookie selections:", localStorageCookieSelections);
              selections = localStorageCookieSelections ? function () {
                try {
                  return JSON.parse(localStorageCookieSelections);
                } catch (_a) {
                  return {
                    personalization: false,
                    marketing: false,
                    analytics: false
                  };
                }
              }() : {
                personalization: false,
                marketing: false,
                analytics: false
              };
              console.log("Parsed local selections:", selections);
              defaultConsent = {
                functionality_storage: "granted",
                analytics_storage: selections.analytics ? "granted" : "denied",
                personalization_storage: selections.personalization ? "granted" : "denied",
                ad_personalization: selections.personalization ? "granted" : "denied",
                ad_storage: selections.marketing ? "granted" : "denied",
                ad_user_data: selections.marketing ? "granted" : "denied",
                wait_for_update: 3000
              };
              (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, "consent", "default", defaultConsent);
              (_b = window.gtag) === null || _b === void 0 ? void 0 : _b.call(window, "set", "ads_data_redaction", false);
              (_c = window.gtag) === null || _c === void 0 ? void 0 : _c.call(window, "set", "url_passthrough", true);
              if ((_d = window.Shopify) === null || _d === void 0 ? void 0 : _d.loadFeatures) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              _context4.n = 2;
              return new Promise(function (resolve) {
                try {
                  window.Shopify.loadFeatures([{
                    name: "consent-tracking-api",
                    version: "0.1"
                  }], function (error) {
                    if (error) {
                      console.error("Error loading Shopify consent-tracking-api:", error);
                      resolve();
                      return;
                    }
                    _this3.consentApiReady = true;
                    resolve();
                    document.addEventListener("visitorConsentCollected", function () {
                      return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee3() {
                        var _a, _b, _c, v, _t2;
                        return _regenerator().w(function (_context3) {
                          while (1) switch (_context3.p = _context3.n) {
                            case 0:
                              _context3.p = 0;
                              _context3.n = 1;
                              return (_c = (_b = (_a = window.Shopify) === null || _a === void 0 ? void 0 : _a.customerPrivacy) === null || _b === void 0 ? void 0 : _b.currentVisitorConsent) === null || _c === void 0 ? void 0 : _c.call(_b);
                            case 1:
                              v = _context3.v;
                              if (v) {
                                _context3.n = 2;
                                break;
                              }
                              return _context3.a(2);
                            case 2:
                              this.setGroup("personalization", v.preferences === "yes");
                              this.setGroup("marketing", v.marketing === "yes");
                              this.setGroup("analytics", v.analytics === "yes");
                              this.saveSelections();
                              _context3.n = 4;
                              break;
                            case 3:
                              _context3.p = 3;
                              _t2 = _context3.v;
                              console.error("visitorConsentCollected handler error:", _t2);
                            case 4:
                              return _context3.a(2);
                          }
                        }, _callee3, this, [[0, 3]]);
                      }));
                    });
                  });
                } catch (e) {
                  console.error("loadFeatures threw:", e);
                  resolve();
                }
              });
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "ensureGtag",
    value: function ensureGtag() {
      window.dataLayer = window.dataLayer || [];
      if (!window.gtag) {
        window.gtag = function gtagShim() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          window.dataLayer.push(args);
        };
      }
    }
  }, {
    key: "bindActionButtons",
    value: function bindActionButtons() {
      var allowAllBtn = this.querySelector(".allow-all-btn");
      var allowSelectedBtn = this.querySelector(".allow-selected-btn");
      var rejectBtn = this.querySelector('[data-action="reject"]');
      if (allowAllBtn) allowAllBtn.addEventListener("click", this.handleAllowAll);
      if (allowSelectedBtn) allowSelectedBtn.addEventListener("click", this.handleAllowSelected);
      if (rejectBtn) rejectBtn.addEventListener("click", this.handleReject);
    }
  }, {
    key: "handleAllowAll",
    value: function handleAllowAll() {
      var shopify = {
        preferences: "yes",
        marketing: "yes",
        analytics: "yes"
      };
      var allCheckboxes = this.querySelectorAll("input.ed-checkbox[data-consent]");
      allCheckboxes.forEach(function (checkbox) {
        if (!checkbox.disabled) checkbox.checked = true;
      });
      this.applyConsent(shopify, true);
    }
  }, {
    key: "handleAllowSelected",
    value: function handleAllowSelected() {
      var _this$getSelections = this.getSelections(),
        personalization = _this$getSelections.personalization,
        marketing = _this$getSelections.marketing,
        analytics = _this$getSelections.analytics;
      var shopify = {
        preferences: personalization ? "yes" : "no",
        marketing: marketing ? "yes" : "no",
        analytics: analytics ? "yes" : "no"
      };
      this.applyConsent(shopify, true);
    }
  }, {
    key: "handleReject",
    value: function handleReject() {
      var shopify = {
        preferences: "no",
        marketing: "no",
        analytics: "no"
      };
      this.applyConsent(shopify, true);
    }
  }, {
    key: "seedSelectionsFromHtmlIfFirstVisit",
    value: function seedSelectionsFromHtmlIfFirstVisit() {
      var _a, _b, _c;
      if (localStorage.getItem("cookieSelections")) return;
      var selections = {
        personalization: !!((_a = this.querySelector('input.ed-checkbox[data-consent="personalization"]')) === null || _a === void 0 ? void 0 : _a.checked),
        marketing: !!((_b = this.querySelector('input.ed-checkbox[data-consent="marketing"]')) === null || _b === void 0 ? void 0 : _b.checked),
        analytics: !!((_c = this.querySelector('input.ed-checkbox[data-consent="analytics"]')) === null || _c === void 0 ? void 0 : _c.checked)
      };
      console.log("[CookieBanner] SEEDING localStorage (this happens before banner check!):", selections);
      localStorage.setItem("cookieSelections", JSON.stringify(selections));
    }
  }, {
    key: "setGroup",
    value: function setGroup(key, checked) {
      var boxes = this.querySelectorAll("input.ed-checkbox[data-consent=\"".concat(key, "\"]"));
      boxes.forEach(function (cb) {
        if (!cb.disabled) cb.checked = checked;
      });
    }
  }, {
    key: "restoreSelections",
    value: function restoreSelections() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee5() {
        var raw, selections;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              raw = localStorage.getItem("cookieSelections");
              if (raw) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              try {
                selections = JSON.parse(raw);
                this.setGroup("personalization", selections.personalization);
                this.setGroup("marketing", selections.marketing);
                this.setGroup("analytics", selections.analytics);
              } catch (event) {
                console.warn("Invalid cookieSelections in localStorage; leaving HTML defaults.", event);
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "saveSelections",
    value: function saveSelections() {
      var selections = this.getSelections();
      localStorage.setItem("cookieSelections", JSON.stringify(selections));
    }
  }, {
    key: "getSelections",
    value: function getSelections() {
      var _this4 = this;
      var isConsentChecked = function isConsentChecked(consentType) {
        var _a;
        return !!((_a = _this4.querySelector("input.ed-checkbox[data-consent=\"".concat(consentType, "\"]"))) === null || _a === void 0 ? void 0 : _a.checked);
      };
      return {
        personalization: isConsentChecked("personalization"),
        marketing: isConsentChecked("marketing"),
        analytics: isConsentChecked("analytics")
      };
    }
  }, {
    key: "applyConsent",
    value: function applyConsent(shopify, hide) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee6() {
        var _a, _b, _c, _d, google;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              google = {
                functionality_storage: "granted",
                analytics_storage: shopify.analytics === "yes" ? "granted" : "denied",
                personalization_storage: shopify.preferences === "yes" ? "granted" : "denied",
                ad_personalization: shopify.preferences === "yes" ? "granted" : "denied",
                ad_storage: shopify.marketing === "yes" ? "granted" : "denied",
                ad_user_data: shopify.marketing === "yes" ? "granted" : "denied",
                wait_for_update: 3000
              };
              (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, "consent", "update", google);
              this.saveSelections();
              (_d = (_c = (_b = window.Shopify) === null || _b === void 0 ? void 0 : _b.customerPrivacy) === null || _c === void 0 ? void 0 : _c.setTrackingConsent) === null || _d === void 0 ? void 0 : _d.call(_c, {
                analytics: shopify.analytics === "yes",
                marketing: shopify.marketing === "yes",
                preferences: shopify.preferences === "yes"
              });
              if (hide) this.hideBanner();
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "getOverlay",
    value: function getOverlay() {
      return this.querySelector("[data-cookie-overlay]") || this;
    }
  }, {
    key: "showBanner",
    value: function showBanner() {
      var element = this.getOverlay();
      element.removeAttribute("hidden");
      element.classList.remove("!tw-hidden");
    }
  }, {
    key: "hideBanner",
    value: function hideBanner() {
      var element = this.getOverlay();
      element.classList.add("!tw-hidden");
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define("cookie-banner", CookieBanner);

/***/ }),

/***/ "./src/TermsAndConditions.ts":
/*!***********************************!*\
  !*** ./src/TermsAndConditions.ts ***!
  \***********************************/
/***/ (() => {

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
var TermsAndConditions = /*#__PURE__*/function (_HTMLElement) {
  function TermsAndConditions() {
    var _this;
    _classCallCheck(this, TermsAndConditions);
    _this = _callSuper(this, TermsAndConditions);
    _this.termsCheckmark = _this.querySelector(".terms_checkmark");
    _this.termsCheckbox = _this.querySelector("#terms_checkbox");
    _this.checkoutBtn = _this.querySelector("button[name='checkout']") || _this.querySelector("a[href='/checkout']");
    _this.popoverTerms = document.querySelector("#popover_terms");
    _this.popoverTermsContainer = document.querySelector(".popover_terms_container");
    _this.popoverTermsClose = document.querySelector("#popover_terms_close");
    _this.acceptTermsButton = document.querySelector("#accept_terms_button");
    _this.documentClickHandler = _this.documentClickHandler.bind(_this);
    _this.checkoutBtnHandler = _this.checkoutBtnHandler.bind(_this);
    _this.acceptTermsCloseHandler = _this.acceptTermsCloseHandler.bind(_this);
    _this.acceptTermsButtonHandler = _this.acceptTermsButtonHandler.bind(_this);
    _this.termsCheckboxChangeHandler = _this.termsCheckboxChangeHandler.bind(_this);
    return _this;
  }
  _inherits(TermsAndConditions, _HTMLElement);
  return _createClass(TermsAndConditions, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (this.checkoutBtn && this.termsCheckbox) {
        this.checkoutBtn.addEventListener("click", this.checkoutBtnHandler);
        this.popoverTermsClose.addEventListener("click", this.acceptTermsCloseHandler);
        this.termsCheckbox.addEventListener("change", this.termsCheckboxChangeHandler);
        this.acceptTermsButton.addEventListener("click", this.acceptTermsButtonHandler);
      }
    }
  }, {
    key: "checkoutBtnHandler",
    value: function checkoutBtnHandler(e) {
      if (!this.termsCheckbox.checked) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.popoverTerms.classList.remove("tw-hidden");
      }
    }
  }, {
    key: "termsCheckboxChangeHandler",
    value: function termsCheckboxChangeHandler() {
      if (this.termsCheckbox.checked) {
        this.checkoutBtn.setAttribute("name", "checkout");
      } else {
        this.checkoutBtn.removeAttribute("name");
      }
    }
  }, {
    key: "acceptTermsButtonHandler",
    value: function acceptTermsButtonHandler() {
      var _this2 = this;
      this.termsCheckbox.click();
      this.termsCheckboxChangeHandler();
      setTimeout(function () {
        if (_this2.termsCheckbox.checked) {
          _this2.checkoutBtn.click();
        }
      }, 200);
    }
  }, {
    key: "documentClickHandler",
    value: function documentClickHandler(e) {
      var target = e.target;
      if (this.popoverTerms && !this.popoverTermsContainer.contains(target) && !this.checkoutBtn.contains(target)) {
        this.popoverTerms.classList.add("tw-hidden");
      }
    }
  }, {
    key: "acceptTermsCloseHandler",
    value: function acceptTermsCloseHandler(e) {
      e.preventDefault();
      this.popoverTerms.classList.add("tw-hidden");
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("terms-conditions", TermsAndConditions);

/***/ }),

/***/ "./src/app.js":
/*!********************!*\
  !*** ./src/app.js ***!
  \********************/
/***/ (() => {



/***/ }),

/***/ "./src/app.scss":
/*!**********************!*\
  !*** ./src/app.scss ***!
  \**********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/app.ts":
/*!********************!*\
  !*** ./src/app.ts ***!
  \********************/
/***/ (function() {

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _this = this;
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var defaultConsentSettings = {
  functionality_storage: 'granted',
  analytics_storage: 'denied',
  personalization_storage: 'denied',
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  wait_for_update: 500
};
function updateConsentSettings(visitorConsent) {
  var consentUpdate = {
    functionality_storage: visitorConsent.preferences === 'yes' ? 'granted' : 'denied',
    analytics_storage: visitorConsent.analytics === 'yes' ? 'granted' : 'denied',
    personalization_storage: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
    ad_storage: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
    ad_user_data: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
    ad_personalization: visitorConsent.marketing === 'yes' ? 'granted' : 'denied'
  };
  // Merge default settings with visitor consent settings. If the visitor has not consented to a particular category, the default setting will be used.
  var mergedSettings = Object.assign(Object.assign({}, defaultConsentSettings), consentUpdate);
  gtag('consent', 'update', mergedSettings);
}
// Event listener for visitor consent collection
document.addEventListener('visitorConsentCollected', function (event) {
  return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
    var visitorConsent;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (!(!window.Shopify || !window.Shopify.customerPrivacy)) {
            _context.n = 1;
            break;
          }
          return _context.a(2);
        case 1:
          _context.n = 2;
          return window.Shopify.customerPrivacy.currentVisitorConsent();
        case 2:
          visitorConsent = _context.v;
          updateConsentSettings(visitorConsent);
        case 3:
          return _context.a(2);
      }
    }, _callee);
  }));
});
// Fetch and update consent settings on page load
function getVisitorConsent() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee2() {
    var visitorConsent;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          if (!(!window.Shopify || !window.Shopify.customerPrivacy)) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2);
        case 1:
          _context2.n = 2;
          return window.Shopify.customerPrivacy.currentVisitorConsent();
        case 2:
          visitorConsent = _context2.v;
          updateConsentSettings(visitorConsent);
        case 3:
          return _context2.a(2);
      }
    }, _callee2);
  }));
}
document.addEventListener('DOMContentLoaded', getVisitorConsent);
// Function to open the login modal
var openLoginModal = function openLoginModal() {
  var loginModal = document.getElementById('login-modal');
  if (loginModal) {
    loginModal.classList.remove('!tw-hidden');
  }
};
var closeLoginModal = function closeLoginModal() {
  var loginModal = document.getElementById('login-modal');
  if (loginModal) {
    loginModal.classList.add('!tw-hidden');
  }
};
var wishlistLoginButton = document.querySelectorAll('.wishlist_login_button');
if (wishlistLoginButton) {
  wishlistLoginButton.forEach(function (button) {
    button.addEventListener('click', openLoginModal);
  });
}
var loginModal = document.getElementById('login-modal');
if (loginModal) {
  loginModal.addEventListener('click', function (event) {
    var modalContent = document.getElementById('login-modal-content');
    if (modalContent && !modalContent.contains(event.target)) {
      closeLoginModal();
    }
  });
}
var closeButton = document.querySelectorAll('.close-modal-button');
if (closeButton) {
  closeButton.forEach(function (button) {
    button.addEventListener('click', closeLoginModal);
  });
}
function handleComponentUpdate() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee3() {
    var response, data, parser, parsedDocument, freshComponents, currentComponents, _t;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          _context3.p = 0;
          _context3.n = 1;
          return fetch("".concat(window.location.href, "?section_id=main-product"));
        case 1:
          response = _context3.v;
          if (response.ok) {
            _context3.n = 2;
            break;
          }
          throw new Error("HTTP error! status: ".concat(response.status));
        case 2:
          _context3.n = 3;
          return response.text();
        case 3:
          data = _context3.v;
          parser = new DOMParser();
          parsedDocument = parser.parseFromString(data, 'text/html');
          freshComponents = parsedDocument.querySelectorAll('wishlist-button');
          currentComponents = document.querySelectorAll('wishlist-button');
          currentComponents.forEach(function (currentComponent, index) {
            var freshComponent = freshComponents[index];
            if (freshComponent) {
              if (currentComponent.outerHTML !== freshComponent.outerHTML) {
                currentComponent.replaceWith(freshComponent);
              }
            }
          });
          _context3.n = 5;
          break;
        case 4:
          _context3.p = 4;
          _t = _context3.v;
          console.error('Error fetching product page:', _t);
        case 5:
          return _context3.a(2);
      }
    }, _callee3, null, [[0, 4]]);
  }));
}
document.addEventListener('cc-variant-changed', function (event) {
  return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee4() {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _context4.n = 1;
          return handleComponentUpdate();
        case 1:
          return _context4.a(2);
      }
    }, _callee4);
  }));
});
var Anyday = /*#__PURE__*/function (_HTMLElement) {
  function Anyday() {
    var _this2;
    _classCallCheck(this, Anyday);
    _this2 = _callSuper(this, Anyday);
    _this2.openModal = _this2.openModal.bind(_this2);
    _this2.closeModal = _this2.closeModal.bind(_this2);
    _this2.getContentFromSection = _this2.getContentFromSection.bind(_this2);
    _this2.handleSelection = _this2.handleSelection.bind(_this2);
    return _this2;
  }
  _inherits(Anyday, _HTMLElement);
  return _createClass(Anyday, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.addEventListener('click', this.openModal);
    }
  }, {
    key: "reInitEvents",
    value: function reInitEvents() {
      var _this3 = this;
      var closeBtn = document.querySelector('.anyday-dialog-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', this.closeModal);
      }
      var options = document.querySelectorAll('.anyday-payment-option');
      options.forEach(function (option) {
        option.addEventListener('click', function () {
          _this3.handleSelection(options, option);
        });
      });
    }
  }, {
    key: "openModal",
    value: function openModal() {
      this.getContentFromSection();
      var anydayOverlay = document.querySelector('.anyday-overlay-mask');
      var anydayModal = document.querySelector('.anyday-dialog-box');
      if (anydayOverlay) {
        anydayOverlay.style.zIndex = '9999';
        anydayOverlay.classList.add('anyday-overlay-active');
      }
      if (anydayModal) {
        anydayModal.classList.add('anyday-show');
      }
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "closeModal",
    value: function closeModal() {
      var anydayOverlay = document.querySelector('.anyday-overlay-mask');
      var anydayModal = document.querySelector('.anyday-dialog-box');
      if (anydayOverlay) {
        anydayOverlay.style.zIndex = '-1';
        anydayOverlay.classList.remove('anyday-overlay-active');
      }
      if (anydayModal) {
        anydayModal.classList.remove('anyday-show');
      }
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "handleSelection",
    value: function handleSelection(options, option) {
      options.forEach(function (opt) {
        opt.classList.remove('anyday-payment-option-selected');
      });
      option.classList.add('anyday-payment-option-selected');
    }
  }, {
    key: "getContentFromSection",
    value: function getContentFromSection() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee5() {
        var url, response, responseText, fresh, selectorElement, freshContent, _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              // eslint-disable-next-line prefer-destructuring
              url = this.dataset.url;
              _context5.p = 1;
              _context5.n = 2;
              return window.fetch("".concat(url, "?section_id=anyday"));
            case 2:
              response = _context5.v;
              if (!response.ok) {
                _context5.n = 5;
                break;
              }
              _context5.n = 3;
              return response.text();
            case 3:
              responseText = _context5.v;
              fresh = document.createElement('div');
              fresh.innerHTML = responseText;
              selectorElement = document.querySelector('[data-anyday-content]');
              freshContent = fresh.querySelector('[data-anyday-content]');
              if (!(selectorElement && freshContent)) {
                _context5.n = 5;
                break;
              }
              if (!(selectorElement.innerHTML === freshContent.innerHTML)) {
                _context5.n = 4;
                break;
              }
              return _context5.a(2);
            case 4:
              selectorElement.innerHTML = freshContent.innerHTML;
            case 5:
              _context5.n = 7;
              break;
            case 6:
              _context5.p = 6;
              _t2 = _context5.v;
              _t2.log(_t2);
            case 7:
              _context5.p = 7;
              this.reInitEvents();
              return _context5.f(7);
            case 8:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 6, 7, 8]]);
      }));
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('edition-anyday', Anyday);

/***/ }),

/***/ "./src/reload-cart.ts":
/*!****************************!*\
  !*** ./src/reload-cart.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionReloadCart)
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var EditionReloadCart = /*#__PURE__*/function () {
  function EditionReloadCart() {
    _classCallCheck(this, EditionReloadCart);
    // Binding the context of "this" to the methods
    this.reloadCart = this.reloadCart.bind(this);
    this.init = this.init.bind(this);
  }
  return _createClass(EditionReloadCart, [{
    key: "init",
    value: function init() {
      // Attaching an event listener for the custom 'Edition:cart:reload' event
      document.addEventListener('Edition:cart:reload', this.reloadCart);
    }
    // Method to reload the cart content
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "reloadCart",
    value: function reloadCart() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
        var response, responseText, fresh, cart, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return window.fetch("".concat(window.Shopify.routes.root_url, "?section_id=cart-drawer"));
            case 1:
              response = _context.v;
              if (!response.ok) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return response.text();
            case 2:
              responseText = _context.v;
              fresh = document.createElement('div');
              fresh.innerHTML = responseText;
              cart = document.getElementById('cart-drawer');
              if (cart) {
                cart.innerHTML = fresh.innerHTML;
              } else {
                console.warn('Cart element not found');
              }
              _context.n = 4;
              break;
            case 3:
              throw new Error('Failed to fetch cart');
            case 4:
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              console.error('Error fetching cart:', _t);
            case 6:
              return _context.a(2);
          }
        }, _callee, null, [[0, 5]]);
      }));
    }
  }]);
}();


/***/ }),

/***/ "./src/wishlist.ts":
/*!*************************!*\
  !*** ./src/wishlist.ts ***!
  \*************************/
/***/ (function() {

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
function fetchProductAndUpdateButton() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
    var productUrl, response, data, variants, selectedVariant, wishlistButton, localWishlistItems, wishlistItems, exists, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          productUrl = window.productUrl;
          _context.p = 1;
          _context.n = 2;
          return fetch("".concat(productUrl, ".json"));
        case 2:
          response = _context.v;
          _context.n = 3;
          return response.json();
        case 3:
          data = _context.v;
          if (!response.ok) {
            _context.n = 4;
            break;
          }
          variants = data.product.variants;
          selectedVariant = variants.find(function (variant) {
            return window.location.href.includes("variant=".concat(variant.id));
          });
          if (selectedVariant) {
            wishlistButton = document.querySelector("wishlist-button");
            wishlistButton.dataset.title = "".concat(data.product.title, " ").concat(selectedVariant.title);
            wishlistButton.dataset.id = selectedVariant.id;
            wishlistButton.dataset.price = selectedVariant.price.toString();
            wishlistButton.dataset.url = productUrl;
            wishlistButton.dataset.handle = data.product.handle;
            wishlistButton.dataset.images = selectedVariant.featured_image.src;
            wishlistButton.dataset.cart =  true ? "true" : 0;
            localWishlistItems = localStorage.getItem("wishlist_items");
            wishlistItems = localWishlistItems ? JSON.parse(localWishlistItems) : [];
            exists = wishlistItems.some(function (item) {
              return item.id == selectedVariant.id;
            });
            if (exists) {
              wishlistButton.classList.add("is-animating");
            } else {
              wishlistButton.classList.remove("is-animating");
            }
          }
          _context.n = 5;
          break;
        case 4:
          console.log(response);
          throw new Error("Network response was not ok");
        case 5:
          _context.n = 7;
          break;
        case 6:
          _context.p = 6;
          _t = _context.v;
          console.log(_t);
        case 7:
          _context.p = 7;
          document.dispatchEvent(new Event("wishlist-changed"));
          return _context.f(7);
        case 8:
          return _context.a(2);
      }
    }, _callee, null, [[1, 6, 7, 8]]);
  }));
}
function removeItemFromCart(variantId) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee2() {
    var response, data, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          if (variantId) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2);
        case 1:
          _context2.p = 1;
          _context2.n = 2;
          return fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              updates: _defineProperty({}, variantId, 0)
            })
          });
        case 2:
          response = _context2.v;
          if (!response.ok) {
            _context2.n = 4;
            break;
          }
          _context2.n = 3;
          return response.json();
        case 3:
          data = _context2.v;
        case 4:
          if (response.ok) {
            _context2.n = 5;
            break;
          }
          console.log(response);
          throw new Error("Network response was not ok");
        case 5:
          _context2.n = 7;
          break;
        case 6:
          _context2.p = 6;
          _t2 = _context2.v;
          console.log(_t2);
        case 7:
          _context2.p = 7;
          document.dispatchEvent(new Event("wishlist-changed"));
          return _context2.f(7);
        case 8:
          return _context2.a(2);
      }
    }, _callee2, null, [[1, 6, 7, 8]]);
  }));
}
function AddToCart(FormData) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee3() {
    var response, data, _t3;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          _context3.p = 0;
          _context3.n = 1;
          return fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(FormData)
          });
        case 1:
          response = _context3.v;
          if (!response.ok) {
            _context3.n = 3;
            break;
          }
          _context3.n = 2;
          return response.json();
        case 2:
          data = _context3.v;
        case 3:
          if (response.ok) {
            _context3.n = 4;
            break;
          }
          console.log(response);
          throw new Error("Network response was not ok");
        case 4:
          _context3.n = 6;
          break;
        case 5:
          _context3.p = 5;
          _t3 = _context3.v;
          console.log(_t3);
        case 6:
          _context3.p = 6;
          document.dispatchEvent(new CustomEvent("theme:cartchanged", {
            bubbles: true,
            cancelable: false
          }));
          document.dispatchEvent(new CustomEvent("theme:open-cart-drawer", {
            bubbles: true,
            cancelable: false
          }));
          document.dispatchEvent(new Event("wishlist-changed"));
          return _context3.f(6);
        case 7:
          return _context3.a(2);
      }
    }, _callee3, null, [[0, 5, 6, 7]]);
  }));
}
function renderWishList(wishlistItems) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee4() {
    var itemHTML, _iterator, _step, _loop, _t4;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          itemHTML = "";
          _iterator = _createForOfIteratorHelper(wishlistItems);
          _context5.p = 1;
          _loop = /*#__PURE__*/_regenerator().m(function _loop() {
            var item, handle, productUrl, productResponse, productData, variants, currentVariantId, currentVariant, currentVariantTitle, productJson, preorderInfo, preorderInfoArray, currentVariantIsPreoder, currentVariantIsAvailable, variantListItems, customDropdownHTML, status, removeTextData, addToCartTextData, soldOutTextData, availability, opacity, color, waitlistLabel, comparePriceHtml, saleLabelText, showPreOrderLabel, productLabel;
            return _regenerator().w(function (_context4) {
              while (1) switch (_context4.n) {
                case 0:
                  item = _step.value;
                  handle = item.handle;
                  productUrl = "/products/".concat(handle);
                  _context4.n = 1;
                  return fetch("".concat(productUrl, ".js"));
                case 1:
                  productResponse = _context4.v;
                  _context4.n = 2;
                  return productResponse.json();
                case 2:
                  productData = _context4.v;
                  variants = productData.variants;
                  currentVariantId = Number(item.id);
                  currentVariant = variants.find(function (v) {
                    return v.id === currentVariantId;
                  });
                  currentVariantTitle = currentVariant ? currentVariant.title : "";
                  productJson = item.productjson;
                  console.log("item", item);
                  // preorder is a string like this "[{'54963773964661': 'true'},{'54963773997429': 'true'},{'54963774030197': 'true'},{'54963774062965': 'true'}]"
                  // I want it as an array of objects like this [{id: 54963773964661, available: true}, {id: 54963773997429, available: true}, ...]
                  preorderInfo = item.preorderinfo;
                  if (preorderInfo !== "[]" && preorderInfo !== "" && preorderInfo !== null && preorderInfo !== undefined) {
                    preorderInfoArray = preorderInfo.replace(/[\[\]{}']/g, "").split(",").map(function (item) {
                      var _item$split = item.split(":"),
                        _item$split2 = _slicedToArray(_item$split, 2),
                        id = _item$split2[0],
                        preorder = _item$split2[1];
                      var preOrderValue = preorder.trim() === "true";
                      //  return the id and boolean value of preorder
                      return {
                        id: Number(id),
                        preorder: preOrderValue
                      };
                    });
                  }
                  // check if the currentVariant is preorder
                  currentVariantIsPreoder = preorderInfoArray ? preorderInfoArray.find(function (item) {
                    return item.id === currentVariantId && item.preorder;
                  }) : false;
                  currentVariantIsAvailable = currentVariant ? currentVariant.available : false;
                  console.log("variants", variants);
                  variantListItems = "";
                  variants.forEach(function (variant) {
                    var variantIdNum = Number(variant.id);
                    var isPreOrder = preorderInfoArray ? preorderInfoArray.find(function (item) {
                      return item.id === variantIdNum && item.preorder;
                    }) : false;
                    var isAvailable = variant.available;
                    console.log("variant is available", isAvailable);
                    variantListItems += "\n        <li\n          class=\"variant-item ".concat(variantIdNum === currentVariantId ? "selected" : "", "\"\n          data-variant-id=\"").concat(variantIdNum, "\"\n          data-available=\"").concat(isAvailable, "\"\n        >\n          <span style=\"font-weight:500; ").concat(!isAvailable ? "color:darkgray;" : "", "\">\n            ").concat(variant.title, "\n          </span>\n          ").concat(isPreOrder ? "<span style=\"text-align:right;\">Forudbestil</span>" : "", "\n        </li>\n      ");
                  });
                  // Create the custom dropdown with the known variant title
                  customDropdownHTML = "\n      <div class=\"custom-dropdown wishlist_variant_picker\">\n        <div class=\"selected-variant\">\n            <span style=\"font-weight:500;\">".concat(currentVariantTitle, "</span>\n            ").concat(currentVariantIsPreoder ? "<span style=\"text-align:right;\">Forudbestil</span>" : "", "\n        </div>\n        <ul class=\"variant-list\" style=\"display: none;\">\n          ").concat(variantListItems, "\n        </ul>\n      </div>\n    ");
                  _context4.n = 3;
                  return getProductData(productUrl, currentVariantId);
                case 3:
                  status = _context4.v;
                  removeTextData = document.querySelector(".wishlist_element_wrapper").getAttribute("data-remove-text");
                  addToCartTextData = document.querySelector(".wishlist_element_wrapper").getAttribute("data-add-to-cart-text");
                  soldOutTextData = document.querySelector(".wishlist_element_wrapper").getAttribute("data-sold-out-text"); // If status is false => product is sold out
                  availability = status ? "" : "disabled";
                  opacity = status ? "" : "tw-opacity-50";
                  color = status ? "tw-bg-[#196450]" : "tw-bg-[#6b6b6b]";
                  waitlistLabel = !status ? "<span class=\"wishlist_waite_badge product-label product-label--sale\">\n           <img height=\"55\" width=\"55\" loading=\"lazy\" src=\"//fashionbystrand.com/cdn/shop/t/117/assets/tilmeld-venteliste.png?v=7240073107463983851741353376\" alt=\"Tilmeld venteliste\">\n         </span>" : "";
                  comparePriceHtml = item.compare_at_price ? "<span class=\"product-price__item product-price__compare theme-money\">".concat(item.compare_at_price, "</span>") : "";
                  saleLabelText = item.salelabeltext ? "<span class=\"wishlist_sale_badge product-label product-label--sale ".concat(item.productlabel ? "!tw-top-[40px]" : "", "\"><span>").concat(item.salelabeltext, "</span></span>") : "";
                  showPreOrderLabel = item.preorderbadge === "true" ? "<span class=\"product-price__item price-label price-label--preorder !tw-left-[10px] !tw-top-[10px]\">".concat(item.preordertext, "</span>") : "";
                  productLabel = item.productlabel ? "<span class=\"wishlist_product_label product-label product-label--meta\">\n          <span>".concat(item.productlabel, "</span>\n          </span>") : "";
                  itemHTML += "\n      <div data-id=\"".concat(item.id, "\" data-handle=\"").concat(item.handle, "\" class=\"wishlist-item\">\n        <div class=\"wishlist-item-info wishlist_item_info\">\n          <div class=\"wishlist_item_image_wrapper\">\n            <a class=\"wishlist_image_wrapper\" href=\"").concat(item.url, "\">\n              ").concat(waitlistLabel, "\n              ").concat(productLabel, "\n              ").concat(showPreOrderLabel, "\n              ").concat(saleLabelText, "\n              <img \n                class=\"wishlist_item_image  ").concat(opacity, "\" \n                style=\"--wh-ratio: 1.0;width:100%;\" \n                src=\"").concat(item.images, "\" \n                alt=\"").concat(item.title, "\" \n              />\n            </a>\n            <div class=\"wishlist_button_wrapper ").concat(opacity, "\">\n              ").concat(customDropdownHTML, "              \n              <wishlist-add_to_cart class=\"wishlist_item_buy_button\" data-id=\"").concat(item.id, "\">\n                <button class=\"wishlist_add_to_cart_button ").concat(color, "\" ").concat(availability, ">\n                  <svg \n                    class=\"js-go-cart-add-to-cart svgcart\" \n                    width=\"20px\" \n                    height=\"20px\" \n                    viewBox=\"0 0 24 24\" \n                    aria-hidden=\"true\"\n                  >\n                    <g \n                      class=\"js-go-cart-add-to-cart\" \n                      stroke=\"none\" \n                      stroke-width=\"1\" \n                      fill=\"none\" \n                      fill-rule=\"evenodd\"\n                    >\n                      <path \n                        class=\"js-go-cart-add-to-cart\" \n                        d=\"M3.5,2.75 C4.87766445,2.75 5.56649668,2.75 5.56649668,2.75 C5.56649668,2.75 6.03257795,7.25 6.96474049,16.25 L19.5,16.25\" \n                        stroke=\"currentColor\" \n                        stroke-width=\"1.5\" \n                        stroke-linecap=\"square\"\n                      ></path>\n                      <path \n                        class=\"js-go-cart-add-to-cart\" \n                        d=\"M6.22627526,6.67553191 C14.8659742,6.67553191 19.1858237,6.67553191 19.1858237,6.67553191 C19.1858237,6.67553191 18.9160351,8.71453901 18.376458,12.7925532 L7.62925996,13.9095745\" \n                        stroke=\"currentColor\" \n                        stroke-width=\"1.5\" \n                        stroke-linecap=\"square\"\n                      ></path>\n                      <circle \n                        class=\"js-go-cart-add-to-cart\" \n                        stroke=\"currentColor\" \n                        stroke-width=\"1.25\" \n                        cx=\"8.875\" \n                        cy=\"20.005\" \n                        r=\"1.375\"\n                      ></circle>\n                      <circle \n                        class=\"js-go-cart-add-to-cart\" \n                        stroke=\"currentColor\" \n                        stroke-width=\"1.25\" \n                        cx=\"17.375\" \n                        cy=\"20.005\" \n                        r=\"1.375\"\n                      ></circle>\n                    </g>\n                  </svg>\n                </button>\n              </wishlist-add_to_cart>\n            </div>\n          </div>\n          <a href=\"").concat(item.url, "\" class=\"").concat(opacity, "\">\n            <div class=\"product-block__title wishlist_item_title\">").concat(item.title, "</div>\n            <p class=\"product-price__item tw-m-0 wishlist_item_price product-price__amount theme-money\">\n              <span>").concat(item.price, "</span><span class=\"product-price__compare theme-money\">").concat(comparePriceHtml, "</span>\n            </p>\n          </a>\n          <remove-item class=\"wishlist_remove_item remove-item\">\n            ").concat(removeTextData, "\n          </remove-item>\n        </div>\n      </div>\n    ");
                case 4:
                  return _context4.a(2);
              }
            }, _loop);
          });
          _iterator.s();
        case 2:
          if ((_step = _iterator.n()).done) {
            _context5.n = 4;
            break;
          }
          return _context5.d(_regeneratorValues(_loop()), 3);
        case 3:
          _context5.n = 2;
          break;
        case 4:
          _context5.n = 6;
          break;
        case 5:
          _context5.p = 5;
          _t4 = _context5.v;
          _iterator.e(_t4);
        case 6:
          _context5.p = 6;
          _iterator.f();
          return _context5.f(6);
        case 7:
          // Attach dropdown event listeners after HTML is in the DOM
          setTimeout(function () {
            attachCustomDropdownListeners();
          }, 0);
          return _context5.a(2, itemHTML);
      }
    }, _callee4, null, [[1, 5, 6, 7]]);
  }));
}
function attachCustomDropdownListeners() {
  document.querySelectorAll(".custom-dropdown .selected-variant").forEach(function (selectedEl) {
    selectedEl.addEventListener("click", function () {
      var variantListEl = selectedEl.nextElementSibling;
      if (variantListEl instanceof HTMLElement) {
        if (variantListEl.style.display === "none") {
          variantListEl.style.display = "block";
        } else {
          variantListEl.style.display = "none";
        }
      }
    });
  });
  document.querySelectorAll(".custom-dropdown .variant-item").forEach(function (variantEl) {
    variantEl.addEventListener("click", function (e) {
      if (variantEl.dataset.available === "false") {
        var BISTrigger = variantEl.nextElementSibling;
        if (BISTrigger) {
          e.preventDefault();
          BISTrigger.click();
        }
      }
      var clickedVariantId = variantEl.getAttribute("data-variant-id");
      var innerHTML = variantEl.innerHTML;
      var variantTitle = variantEl.textContent.trim();
      var siblings = variantEl.parentElement.querySelectorAll(".variant-item");
      siblings.forEach(function (sib) {
        return sib.classList.remove("selected");
      });
      variantEl.classList.add("selected");
      var selectedVariantEl = variantEl.parentElement.previousElementSibling;
      selectedVariantEl.innerHTML = innerHTML;
      var wishlistItemEl = variantEl.closest(".wishlist-item");
      if (wishlistItemEl) {
        var buyButton = wishlistItemEl.querySelector(".wishlist_item_buy_button");
        if (buyButton) {
          buyButton.setAttribute("data-id", clickedVariantId);
        }
      }
      variantEl.parentElement.style.display = "none";
    });
  });
}
document.addEventListener("DOMContentLoaded", function () {
  var wishlistModule = document.querySelector(".wishlist-module");
  if (wishlistModule) {
    wishlistModule.addEventListener("change", function (event) {
      var target = event.target;
      if (target.classList.contains("wishlist_variant_picker")) {
        var selectedVariantId = target.value;
        var selectedOption = target.options[target.selectedIndex];
        var wishlistItem = target.closest(".wishlist-item");
        var wishlistButton = wishlistItem.querySelector("wishlist-add_to_cart");
        var wishlistImage = wishlistItem.querySelector(".wishlist_item_image");
        var wishlistPrice = wishlistItem.querySelector(".wishlist_item_price");
        wishlistItem.dataset.id = selectedVariantId;
        wishlistButton.dataset.id = selectedVariantId;
        wishlistImage.src = selectedOption.getAttribute("data-image") || "";
        wishlistPrice.textContent = "".concat(Number(selectedOption.getAttribute("data-price")) / 100, " USD");
        var localWishlistItems = JSON.parse(localStorage.getItem("wishlist_items") || "[]");
        var updatedWishlistItems = localWishlistItems.map(function (item) {
          if (item.id == wishlistItem.dataset.id) {
            return Object.assign(Object.assign({}, item), {
              id: selectedVariantId,
              price: selectedOption.getAttribute("data-price"),
              compare_at_price: selectedOption.getAttribute("data-compare-at-price")
            });
          }
          return item;
        });
        localStorage.setItem("wishlist_items", JSON.stringify(updatedWishlistItems));
      }
    });
  }
});
function renderWishlistModule() {
  var localWishlistItems = localStorage.getItem("wishlist_items");
  var wishlistItems = localWishlistItems ? JSON.parse(localWishlistItems) : [];
  var wishlistModule = document.querySelector(".wishlist-module");
  var wishlistSection = document.querySelector(".wishlist-section");
  if (wishlistModule) {
    if (wishlistItems.length > 0) {
      wishlistSection.classList.add("active");
      wishlistModule.classList.remove("active");
    } else {
      wishlistModule.classList.add("active");
      wishlistSection.classList.remove("active");
    }
  }
  document.dispatchEvent(new Event("wishlist-changed"));
}
document.addEventListener("DOMContentLoaded", function () {
  renderWishlistModule();
});
var WishlistCount = /*#__PURE__*/function (_HTMLElement) {
  function WishlistCount() {
    _classCallCheck(this, WishlistCount);
    return _callSuper(this, WishlistCount);
  }
  _inherits(WishlistCount, _HTMLElement);
  return _createClass(WishlistCount, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      document.addEventListener("DOMContentLoaded", function () {
        _this.updateCount();
      });
      document.addEventListener("wishlist-changed", function () {
        _this.updateCount();
      });
    }
  }, {
    key: "updateCount",
    value: function updateCount() {
      var localWishlistItems = localStorage.getItem("wishlist_items");
      var wishlistItems = localWishlistItems ? JSON.parse(localWishlistItems) : [];
      this.innerHTML = wishlistItems.length.toString();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("wishlist-count", WishlistCount);
var WishlistButton = /*#__PURE__*/function (_HTMLElement2) {
  function WishlistButton() {
    var _this2;
    _classCallCheck(this, WishlistButton);
    _this2 = _callSuper(this, WishlistButton);
    _this2.id = _this2.dataset.id;
    if (_this2.id === "51068398174537") {
      console.log("constructor", _this2.id);
    }
    return _this2;
  }
  _inherits(WishlistButton, _HTMLElement2);
  return _createClass(WishlistButton, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this3 = this;
      this.updateButtonState();
      if (this.id === "51068398174537") {
        console.log("connectedCallback", this.id);
      }
      this.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        _this3.toggleWishlistItem(event);
      });
      var fieldSet = document.querySelector("fieldset");
      if (fieldSet) {
        fieldSet.addEventListener("change", function () {
          fetchProductAndUpdateButton();
        });
      }
    }
  }, {
    key: "updateButtonState",
    value: function updateButtonState() {
      var localWishlistItems = localStorage.getItem("wishlist_items");
      if (localWishlistItems) {
        var wishlistItems = JSON.parse(localWishlistItems);
        var attributesObject = Object.assign({}, this.dataset);
        var exists = wishlistItems.some(function (item) {
          return item.id == attributesObject.id;
        });
        if (exists) {
          this.classList.add("is-animating");
          if (attributesObject.cart === "true") {
            this.style.display = "none";
          }
        } else {
          this.classList.remove("is-animating");
          if (attributesObject.cart === "true") {
            this.style.display = "block";
          }
        }
      }
      document.dispatchEvent(new Event("wishlist-changed"));
    }
  }, {
    key: "toggleWishlistItem",
    value: function toggleWishlistItem(event) {
      var _this4 = this;
      this.classList.add("is-animating");
      var wishlistModuleBox = document.querySelector("#wishlist-module-box");
      var wishlistModuleImg = wishlistModuleBox.querySelector("#wishlist-module-img");
      var wishlistModuleTitle = wishlistModuleBox.querySelector("#wishlist-module-title");
      var wishlistModuleText = wishlistModuleBox.querySelector("#wishlist-module-text");
      var removeFromWishlistTextData = document.querySelector(".wishlist-button-text").getAttribute("data-removedText");
      var addToWishlistTextData = document.querySelector(".wishlist-button-text").getAttribute("data-addedText");
      wishlistModuleBox.classList.toggle("wishlist_module_alert");
      setTimeout(function () {
        wishlistModuleBox.classList.toggle("wishlist_module_alert");
      }, 1000);
      var localWishlistItems = localStorage.getItem("wishlist_items");
      var wishlistItems = localWishlistItems ? JSON.parse(localWishlistItems) : [];
      var attributesObject = Object.assign({}, this.dataset);
      wishlistModuleImg.setAttribute("src", attributesObject.images);
      wishlistModuleTitle.innerHTML = attributesObject.title;
      if (this.dataset.cart === "true") {
        var exists = wishlistItems.some(function (item) {
          return item.id == attributesObject.id;
        });
        if (!exists) {
          wishlistItems.push(attributesObject);
          localStorage.setItem("wishlist_items", JSON.stringify(wishlistItems));
          wishlistModuleText.innerHTML = removeFromWishlistTextData;
          setTimeout(function () {
            var cartRemoveButton = _this4.closest(".cart-item").querySelector(".cart-item__remove-button");
            if (cartRemoveButton) {
              cartRemoveButton.click();
            }
          }, 1000);
        } else {}
      } else {
        var _exists = wishlistItems.some(function (item) {
          return item.id == attributesObject.id;
        });
        if (!_exists) {
          wishlistItems.push(attributesObject);
          localStorage.setItem("wishlist_items", JSON.stringify(wishlistItems));
          wishlistModuleText.innerHTML = addToWishlistTextData;
          console.log("added to wishlist");
        } else {
          var newWishlistItems = wishlistItems.filter(function (item) {
            return item.id != attributesObject.id;
          });
          localStorage.setItem("wishlist_items", JSON.stringify(newWishlistItems));
          wishlistModuleText.innerHTML = removeFromWishlistTextData;
          console.log("removed from wishlist");
        }
        this.updateButtonState();
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("wishlist-button", WishlistButton);
var WishlistElementsWrapper = /*#__PURE__*/function (_HTMLElement3) {
  function WishlistElementsWrapper() {
    var _this5;
    _classCallCheck(this, WishlistElementsWrapper);
    _this5 = _callSuper(this, WishlistElementsWrapper);
    _this5.url = _this5.dataset.url;
    _this5.getWishlistHtml = function (wishlistItems) {
      return __awaiter(_this5, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee6() {
        var _this6 = this;
        var wishlistProductIds, batchSize, batches, i, responses, template, allHtml, _t5;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              console.log("wishlistItems", wishlistItems);
              _context7.n = 1;
              return Promise.all(wishlistItems.map(function (item) {
                return __awaiter(_this6, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee5() {
                  var id;
                  return _regenerator().w(function (_context6) {
                    while (1) switch (_context6.n) {
                      case 0:
                        id = item.productid;
                        if (id) {
                          _context6.n = 1;
                          break;
                        }
                        return _context6.a(2, "");
                      case 1:
                        return _context6.a(2, "id:".concat(id));
                    }
                  }, _callee5);
                }));
              }));
            case 1:
              wishlistProductIds = _context7.v;
              console.log("wishlistProductIds", wishlistProductIds);
              batchSize = 20;
              batches = [];
              for (i = 0; i < wishlistProductIds.length; i += batchSize) {
                batches.push(wishlistProductIds.slice(i, i + batchSize).join(" OR "));
              }
              _context7.n = 2;
              return Promise.all(batches.map(function (batchQuery) {
                return fetch("".concat(_this6.url, "&q=").concat(batchQuery)).then(function (res) {
                  if (!res.ok) throw new Error("Network response was not ok");
                  return res.text();
                });
              }));
            case 2:
              responses = _context7.v;
              template = document.createElement("template");
              allHtml = responses.map(function (html) {
                template.innerHTML = html;
                console.log("template", template);
                var wishlistWrapper = template.content.querySelector("wishlist-elements-wrapper");
                return wishlistWrapper ? Array.from(wishlistWrapper.children).map(function (child) {
                  return child.outerHTML;
                }).join("") : "";
              }).join("");
              return _context7.a(2, allHtml);
            case 3:
              _context7.p = 3;
              _t5 = _context7.v;
              console.log(_t5);
              return _context7.a(2, "");
          }
        }, _callee6, null, [[0, 3]]);
      }));
    };
    return _this5;
  }
  _inherits(WishlistElementsWrapper, _HTMLElement3);
  return _createClass(WishlistElementsWrapper, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return this.init();
            case 1:
              return _context8.a(2);
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee8() {
        var localWishlistItems, wishlistItems, _t6;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              localWishlistItems = localStorage.getItem("wishlist_items");
              wishlistItems = JSON.parse(localWishlistItems);
              this.innerHTML = "";
              _t6 = "\n        <div class=\"item-container\">\n          <div class=\"custom-grid-container\">\n          ";
              _context9.n = 1;
              return this.getWishlistHtml(wishlistItems);
            case 1:
              this.innerHTML = _t6.concat.call(_t6, _context9.v, "\n          </div>\n        </div>\n      ");
            case 2:
              return _context9.a(2);
          }
        }, _callee8, this);
      }));
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("wishlist-elements-wrapper", WishlistElementsWrapper);
var RemoveItem = /*#__PURE__*/function (_HTMLElement4) {
  function RemoveItem() {
    _classCallCheck(this, RemoveItem);
    return _callSuper(this, RemoveItem);
  }
  _inherits(RemoveItem, _HTMLElement4);
  return _createClass(RemoveItem, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this7 = this;
      this.addEventListener("click", function (event) {
        return __awaiter(_this7, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee9() {
          var localWishlistItems, wishlistItems, id, newWishlistItems, wishlistElementsWrapper;
          return _regenerator().w(function (_context0) {
            while (1) switch (_context0.n) {
              case 0:
                event.preventDefault();
                localWishlistItems = localStorage.getItem("wishlist_items");
                wishlistItems = JSON.parse(localWishlistItems);
                id = this.id;
                console.log("id", id);
                newWishlistItems = wishlistItems.filter(function (item) {
                  return item.productid != id;
                });
                localStorage.setItem("wishlist_items", JSON.stringify(newWishlistItems));
                document.dispatchEvent(new Event("wishlist-changed"));
                wishlistElementsWrapper = document.querySelector("wishlist-elements-wrapper");
                wishlistElementsWrapper.innerHTML = "";
                wishlistElementsWrapper.init();
                window.location.reload();
              case 1:
                return _context0.a(2);
            }
          }, _callee9, this);
        }));
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("remove-item", RemoveItem);
var WishlistAddToCart = /*#__PURE__*/function (_HTMLElement5) {
  function WishlistAddToCart() {
    _classCallCheck(this, WishlistAddToCart);
    return _callSuper(this, WishlistAddToCart);
  }
  _inherits(WishlistAddToCart, _HTMLElement5);
  return _createClass(WishlistAddToCart, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this8 = this;
      var addToCartButton = this.querySelector("button");
      addToCartButton.addEventListener("click", function (event) {
        return __awaiter(_this8, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee0() {
          var _a, wishlistItem, buyButton, selectedVariantId, formData, localWishlistItems, updatedWishlistItems, wishlistElementsWrapper, _t7;
          return _regenerator().w(function (_context1) {
            while (1) switch (_context1.n) {
              case 0:
                event.preventDefault();
                wishlistItem = this.closest(".wishlist-item");
                buyButton = wishlistItem.querySelector(".wishlist_item_buy_button"); // Read the variant ID from the 'data-id' attribute
                selectedVariantId = parseInt((_a = buyButton === null || buyButton === void 0 ? void 0 : buyButton.dataset.id) !== null && _a !== void 0 ? _a : "", 10);
                if (!isNaN(selectedVariantId)) {
                  _context1.n = 1;
                  break;
                }
                console.error("Invalid variant ID selected!");
                return _context1.a(2);
              case 1:
                formData = {
                  items: [{
                    id: selectedVariantId,
                    quantity: 1
                  }]
                };
                _context1.n = 2;
                return AddToCart(formData);
              case 2:
                localWishlistItems = JSON.parse(localStorage.getItem("wishlist_items") || "[]");
                updatedWishlistItems = localWishlistItems.filter(function (item) {
                  return item.id !== selectedVariantId;
                });
                localStorage.setItem("wishlist_items", JSON.stringify(updatedWishlistItems));
                wishlistElementsWrapper = document.querySelector("wishlist-elements-wrapper");
                _t7 = "\n        <div class=\"item-container\">\n          <div class=\"custom-grid-container\">\n            ";
                _context1.n = 3;
                return renderWishList(updatedWishlistItems);
              case 3:
                wishlistElementsWrapper.innerHTML = _t7.concat.call(_t7, _context1.v, "\n          </div>\n        </div>\n      ");
                renderWishlistModule();
                document.dispatchEvent(new CustomEvent("theme:cartchanged", {
                  bubbles: true,
                  cancelable: false
                }));
                document.dispatchEvent(new CustomEvent("theme:open-cart-drawer", {
                  bubbles: true,
                  cancelable: false
                }));
              case 4:
                return _context1.a(2);
            }
          }, _callee0, this);
        }));
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
function getProductData(url, variantId) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee1() {
    var response, data, variants, selectedVariant, status, _t8;
    return _regenerator().w(function (_context10) {
      while (1) switch (_context10.p = _context10.n) {
        case 0:
          _context10.p = 0;
          _context10.n = 1;
          return fetch("".concat(url, ".js"));
        case 1:
          response = _context10.v;
          if (!response.ok) {
            _context10.n = 3;
            break;
          }
          _context10.n = 2;
          return response.json();
        case 2:
          data = _context10.v;
          variants = data.variants;
          selectedVariant = variants.filter(function (variant) {
            return variant.id == variantId;
          });
          status = selectedVariant[0].available;
          return _context10.a(2, status);
        case 3:
          console.log(response);
        case 4:
          _context10.n = 6;
          break;
        case 5:
          _context10.p = 5;
          _t8 = _context10.v;
          console.log(_t8);
        case 6:
          _context10.p = 6;
          return _context10.f(6);
        case 7:
          return _context10.a(2);
      }
    }, _callee1, null, [[0, 5, 6, 7]]);
  }));
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/app": 0,
/******/ 			"assets/app": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkFashionByStrand"] = self["webpackChunkFashionByStrand"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.js")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/Cookiebanner.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/reload-cart.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/TermsAndConditions.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/wishlist.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;